<template>
  <div class="container-fluid">
    <div class="content_box">
      <img src="../assets/chargeTop.png" class="chargeTop" />
      <div class="order_box">
        <div class="chargeViewLabel">
          <span>{{activeConsInfo.balance>=0?'当前金额':'您已欠费'}}</span>
          <span
            class="absPrepaybal"
            style="activeConsInfo.balance>0?'':'color:#ff7613;'"
          >{{activeConsInfo.balance}}</span>
        </div>
        <div class="owe_box" v-if="activeConsInfo.balance<0">您已欠费,请及时充值</div>
        <div class="owe_box" v-else>暂未查询到欠费</div>
        <div class="owe_info">
          <span style="color: #ff353a">*</span>若已停电，交费需大于欠费金额，才可自动复电
        </div>
        <div class="count_box">
          <div class="count_item" style="margin-top: 0.05rem">
            <div class="count_key">客户编号</div>
            <div class="count_value">{{activeConsInfo.consNo}}</div>
          </div>
          <div class="count_item" style="margin-top: 0.1rem">
            <div class="count_key">客户名称</div>
            <div class="count_value">{{activeConsInfo.consName}}</div>
          </div>
          <div class="count_item" style="margin-top: 0.1rem">
            <div class="count_key">客户地址</div>
            <div class="count_value">{{activeConsInfo.elecAddr}}</div>
          </div>
        </div>
        <div class="charge_box">
          <div class="charge_info">充值金额</div>
          <van-field v-model="value1" left-icon="gold-coin-o" placeholder="请输入充值金额" />
          <div class="price_box">
            <div
              @click="changePrice(item)"
              class="recharge_price"
              :style="item==value1?'background-color: #50c7a1;color: #FFFFFF':''"
              v-for="item in recommandPriceList"
            >{{item}}元</div>
          </div>
          
          <div class="charge_info" style="margin-top: 0.3rem">
            <div class="charge_title">请选择支付方式</div>
          </div>
          <div class="payment_box">
            <div class="payment_item">
              <div style="display: flex; align-items: center">
                <img src="@/assets/wx.png" alt class="icon" />
                <span>微信支付</span>
              </div>
              <van-checkbox :value="checkedType=='UNIONPAY_WX'" @click="checkChange('UNIONPAY_WX')" icon-size="18px"></van-checkbox>
            </div>
            <div class="payment_item">
              <div style="display: flex; align-items: center">
                <img src="@/assets/zfb.png" alt class="icon" />
                <span>支付宝支付</span>
              </div>
              <van-checkbox :value="checkedType=='UNIONPAY_ALI'" @click="checkChange('UNIONPAY_ALI')" icon-size="18px"></van-checkbox>
            </div>
            <div class="payment_item">
              <div style="display: flex; align-items: center">
                <img src="@/assets/ysf.jpg" alt class="icon" />
                <span>云闪付支付</span>
              </div>
              <van-checkbox :value="checkedType=='UNIONPAY_UAC'" @click="checkChange('UNIONPAY_UAC')" icon-size="18px"></van-checkbox>
            </div> 
          </div>
        </div>
      </div>
      <img src="../assets/chargeBottom.png" class="chargeTop" />
    </div>
    <div class="recharge_btn" @click="unionPayCreateOrder">立即充值</div>
  </div>
</template>
<script>
import Vue from "vue";
import { Field, Checkbox, Notify, Toast } from "vant";
import { payCreateOrder, queryOpenid, queryBindFeeCons, unionPayCreateOrder } from "@/api/user.js";
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(Notify);
export default {
  data() {
    return {
      consId: "",
      value1: "",
      checkedType: 'UNIONPAY_WX',
      canclick: true,
      activeConsInfo: {},
      recommandPriceList: [100, 200, 300],
      openid: ""
    };
  },
  created() {
    if (this.$route.query.state) {
      this.consId = this.$route.query.state;
      this.queryBindFeeCons(this.consId);
    }

    if (this.$route.query.code) {
      queryOpenid(this.$route.query.code).then(res => {
        if (res.data.status == 200) {
          this.openid = res.data.object;
        }
      });
    }
  },
  methods: {
    changePrice(price) {
      this.value1 = price;
    },
    checkChange(checkedType) {
      this.checkedType = checkedType;
    },
    changeStr(str, index, changeStr) {
      return (
        str.substr(0, index) + changeStr + str.substr(index + changeStr.length)
      );
    },
    //查询当前已绑定的户号
    queryBindFeeCons(consId) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      });

      queryBindFeeCons(consId).then(res => {
        Toast.clear();
        if (res.data.status == 200) {
          this.activeConsInfo = res.data.object;
          if (this.activeConsInfo.balance < 0) {
            this.value1 = Math.abs(this.activeConsInfo.balance);
          }
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    toCharge() {
      if (this.checkedType == 'UNIONPAY_WX') {
        if (!this.canclick) {
          Notify({ type: "danger", message: "请勿重复点击" });
          return;
        }
        if (this.activeConsInfo.balance < 0) {
          if (this.value1 < Math.abs(this.activeConsInfo.balance)) {
            Notify({ type: "danger", message: "充值金额需大于欠费金额！" });
            return;
          }
        }
        this.canclick = false;
        payCreateOrder({
          consId: this.consId,
          orderAmount: this.value1,
          openid: this.openid
        }).then(res => {
          setTimeout(() => {
            this.canclick = true;
          }, 1000);
          if (res.data.status == 200) {
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
                document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
              }
            } else {
              this.onBridgeReady(res.data.object);
            }
          } else {
            Notify({ type: "danger", message: res.data.msg });
          }
        });
      }
    },
    unionPayCreateOrder() {
      if (!this.canclick) {
        Notify({ type: "danger", message: "请勿重复点击" });
        return;
      }

      if (this.activeConsInfo.balance < 0) {
        if (this.value1 < Math.abs(this.activeConsInfo.balance)) {
          Notify({ type: "danger", message: "充值金额需大于欠费金额！" });
          return;
        }
      }

      this.canclick = false;

      unionPayCreateOrder({
        consId: this.consId,
        orderAmount: this.value1,
        payMethod: this.checkedType
      }).then(res => {
        this.canclick = true;
        if (res.data.status == 200) {
          window.location.href = res.data.object;  
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    onBridgeReady(data) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", data, res => {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          this.$router.push({
            path: `/tcmr/paymentRecords?consId=${this.consId}`
          });
        }
      });
    }
  }
};
</script>
<style  scoped>
.recharge_btn {
  color: #fff;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  margin: 0rem 0.3rem;
  margin-top: 0.3rem;
  background: #50c7a1;
  border-radius: 0.06rem;
}
.icon {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.2rem;
}
.payment_item {
  display: flex;
  font-size: 0.26rem;
  margin-top: 0.25rem;
  align-items: center;
  justify-content: space-between;
}
.price_box {
  display: flex;
  margin-top: 0.4rem;
  justify-content: space-between;
}
.recharge_price {
  width: 1.6rem;
  font-size: 0.26rem;
  text-align: center;
  line-height: 0.6rem;
  margin: 0.02rem 0.1rem;
  background-color: #efefef;
}
.van-cell {
  padding: 0.1rem;
  border-bottom: 0.01rem solid rgb(236, 233, 233);
}
.charge_info {
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  font-size: 0.28rem;
  line-height: 0.28rem;
}
.charge_info::before {
  content: "";
  display: inline-block;
  margin-right: 0.08rem;
  width: 0.06rem;
  height: 0.28rem;
  background-color: #50c7a1;
}
.charge_title {
  font-size: 0.26rem;
  margin-left: 0.05rem;
}
.line {
  width: 0.05rem;
  height: 0.3rem;
  background: #378a37;
}
.charge_box {
  padding: 0 0.6rem;
  margin-bottom: 0.2rem;
}

.count_value {
  width: 3.5rem;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 0.52rem;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
.count_key {
  width: 1.5rem;
  text-align: left;
  line-height: 0.52rem;
}
.count_item {
  display: flex;
}
.count_box {
  margin: 0 0.6rem;
  font-size: 0.24rem;
  padding-bottom: 0.4rem;
}
.owe_info {
  color: #666;
  font-size: 0.2rem;
  margin: 0 0.6rem;
  margin-top: 0.05rem;
  padding-bottom: 0.1rem;
  border-bottom: 0.02rem dotted #d8d0d0;
}
.owe_box {
  color: red;
  font-size: 0.22rem;
}
.chargeViewLabel {
  margin-bottom: 0.28rem;
  text-align: center;
  font-size: 0.36rem;
  color: #666;
}
.absPrepaybal {
  margin-left: 0.2rem;
  color: #ff7613;
  font-size: 0.36rem;
}
.container-fluid {
  margin-right: auto;
  margin-left: auto;
  padding-left: 5px;
  padding-right: 5px;
}
.content_box {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.order_box {
  width: 6rem;
  background: url("https://www.sd.sgcc.com.cn/ppm/resources/shop/styleMobile/images/payWay/contentView.png")
    repeat-y;
  background-size: 6rem auto;
}
.info_item {
  display: flex;
}
.notice2 {
  color: #999;
  font-size: 12px;
  margin-top: 6px;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px dotted #ececec;
}

.chargeTop {
  width: 6rem;
}
.order_title {
  margin-bottom: 0.28rem;
  text-align: center;
  font-size: 0.36rem;
  color: #666;
}
.notice {
  font-size: 14px;
  margin-top: 15px;
  color: #ff353a;
  text-align: center;
}
</style>